export default __webpack_public_path__ + "static/media/edit.27909c01.svg";